import { Record as record } from 'immutable';

import trainTime from '../../../../lib/TrainTime';
import { getDefaults, getResolvers } from '../../../../helpers/Records';
import { construct, resolve } from '../../../../helpers/LinkMapper';

const fieldSchema = {
    "accountId": [resolve.with(Number)],
    "startDate": [resolve.with(trainTime)],
    "endDate": [resolve.with(trainTime)]
};

class TransactionHistoryRange extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(TransactionHistoryRange, json, getResolvers(fieldSchema));
    }
}

export default TransactionHistoryRange;
